import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceView } from '../db/models/service-view';

@Injectable({
  providedIn: 'root'
})
export class ViewsService {

  // private baseUrl = 'https://localhost:44352/api/serviceView/';
  private baseUrl = 'https://api.trepezserver.com/api/serviceView/';


  headers = new HttpHeaders()
  .set('Content-Type','application/json')
  .set('Access-Control-Allow-Origin','*')

constructor(private http: HttpClient) { }

RegisterServiceView(data: ServiceView): Observable<ServiceView> {
  // const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  return this.http.post<ServiceView>(this.baseUrl + 'newView', data, { 'headers': this.headers });
}

// getserviceDetail(id:string): Observable<ServiceView>{
//   return this.http.get<ServiceView>(this.baseUrl + 'service/' + id)
// }

}
